import VerificationDataScreen from 'domains/Users/Verification/screens/UserVerification'

export default VerificationDataScreen
